import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Componente que carga y aplica el CSS personalizado globalmente
 * Se incluye en App.js para que afecte a toda la aplicación
 */
export default function CustomCSSLoader() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadCustomCSS();
  }, []);

  const loadCustomCSS = async () => {
    try {
      const response = await axios.get(`${API_URL}/settings/css`);
      const css = response.data.css;
      
      if (css) {
        // Remover estilo anterior si existe
        const existingStyle = document.getElementById('custom-css-global');
        if (existingStyle) {
          existingStyle.remove();
        }
        
        // Crear nuevo elemento de estilo
        const style = document.createElement('style');
        style.id = 'custom-css-global';
        style.textContent = css;
        document.head.appendChild(style);
      }
      
      setLoaded(true);
    } catch (error) {
      // Error silenced: 'Error loading custom CSS:', error);
      setLoaded(true);
    }
  };

  // Este componente no renderiza nada visible
  return null;
}
